(() => {
  if (customElements.get('xp-style-finder')) return;
  customElements.define('xp-style-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const results = this.querySelector('.xps-results');
      const cards = [...this.querySelectorAll('.xps-card')];
      if (new URLSearchParams(location.search).get('xp_style') === '1') this.querySelector('details').open = true;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const answers = new FormData(form);
        const matches = cards.filter(card => ['fit', 'vibe', 'occasion'].every(key => {
          const answer = answers.get(key);
          return answer === 'any' || (card.dataset[key] || '').split(/\s+/).includes(answer);
        }));
        const selected = matches.slice(0, Number(this.dataset.limit) || 6);
        cards.forEach(card => { card.hidden = !selected.includes(card); });
        results.hidden = false;
        this.querySelector('.xps-empty').hidden = matches.length > 0;
        this.querySelector('.xps-status').textContent = matches.length
          ? `Showing ${selected.length} of ${matches.length} available ${matches.length === 1 ? 'pick' : 'picks'} matching your choices.`
          : 'No exact matches for that combination yet.';
        const heading = this.querySelector('.xps-result-heading');
        heading.textContent = matches.length ? 'A few pieces for your next chapter.' : 'Let’s try another combination.';
        heading.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
      form.addEventListener('reset', () => {
        results.hidden = true;
        cards.forEach(card => { card.hidden = true; });
        form.querySelector('input').focus({ preventScroll: true });
      });
    }
  });
})();
